export default __webpack_public_path__ + "static/media/cremation.de19205f.svg";